import {BehaviorSubject} from 'rxjs';

import {handleResponse} from '../api/handleResponse';

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value
    }
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({"name": username, "password": password})
    };

    return fetch(process.env.REACT_APP_API_URL + '/auth/login', requestOptions)
        .then(handleResponse)
        .then(user => {
            user["name"] = username;
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);

            return user;
        }).catch(e => {
            throw new Error("Cannot reach " + process.env.REACT_APP_API_URL + ", error: " + e.toString());
        });
}

function logout() {
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
}